import React from "react";

const IconAlertCircle = ({ size = 17 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2398_17719)">
        <path
          d="M8.4987 14.6673C12.1806 14.6673 15.1654 11.6825 15.1654 8.00065C15.1654 4.31875 12.1806 1.33398 8.4987 1.33398C4.8168 1.33398 1.83203 4.31875 1.83203 8.00065C1.83203 11.6825 4.8168 14.6673 8.4987 14.6673Z"
          stroke="#FFB420"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 5.33398V8.00065"
          stroke="#FFB420"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 10.666H8.50667"
          stroke="#FFB420"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2398_17719">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconAlertCircle;
